import * as types from './types';

const initialState = {
  errors: {},
  loading: false,
  products: [],
  product: {},
};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOAD_PRODUCTS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case types.LOAD_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: action?.payload,
        loading: false,
      };

    case types.LOAD_PRODUCTS_FAIL:
      return {
        ...state,
        errors: action.payload,
        loading: false,
      };

    case types.LOAD_PRODUCT_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case types.LOAD_PRODUCT_SUCCESS:
      return {
        ...state,
        product: action?.payload,
        loading: false,
      };

    case types.LOAD_PRODUCT_FAIL:
      return {
        ...state,
        errors: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default productReducer;
